export const backendHost = process.env.NODE_ENV === 'production'
	? 'event.dorisystems.com' // doc.doriclub.uz
	: 'event.dorisystems.com'
// export const backendHost = 'dev.doclub.uz' // for dev
export const backendPath = 'api'

export default {
	backendHost,
	backendPath,
}
